import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

const StyledToastContainer = styled(ToastContainer)`
	// https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
	&&&.Toastify__toast-container {
		height: auto;
		padding: ${({ theme }) => theme.spacing.small};
	}

	.Toastify__toast {
		padding: 0;
		min-height: 45px;
		background: none !important;
	}

	.Toastify__close-button {
		position: absolute;
		right: 8px;
		top: 54%;
		transform: translateY(-50%);
	}
`;

export default StyledToastContainer;
